import type { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getStoredAccessToken } from "@/shared/utils/auth";

type GuestRouteProps = {
  children?: ReactNode;
  redirectTo?: string;
};

const GuestRoute = ({
  children,
  redirectTo = "/dashboard",
}: GuestRouteProps) => {
  const token = getStoredAccessToken();

  if (token) {
    return <Navigate to={redirectTo} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default GuestRoute;
